import { RESERVEDDatasourceCanInfoIcon } from '@tableau/icons/RESERVEDDatasourceCanInfoIcon';
import { RESERVEDDatasourceCanWarningIcon } from '@tableau/icons/RESERVEDDatasourceCanWarningIcon';
import React from 'react';

export const WarningColumnHeaderIcon = (props: { className?: string }) => <RESERVEDDatasourceCanWarningIcon size={14} style={{ color: '#666666' }} className={props.className} />;

export const WarningHighSeverityIcon = (props: { className?: string }) => <RESERVEDDatasourceCanWarningIcon size={14} style={{ color: '#AC4B02' }} className={props.className} />;

export const WarningStandardSeverityIcon = (props: { className?: string }) => <RESERVEDDatasourceCanInfoIcon size={14} style={{ color: '#05628A' }} className={props.className} />;
